<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0">
        <b-form-select
          style="width:300px;"
          v-model="selectedEvent"
          :options="events"
          class="mt-1"
          @change="onFormChanged()"
        />
        <!--
        <b-form-select
          style="width:300px;"
          v-model="question_id"
          :options="questions"
          class="mt-1 ml-2"
          @change="onFormChanged()"
        />
        -->
      </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <!-- 
            <li>
              <vs-checkbox
                v-model="published_only"
                color="primary"
                :vs-value="true"
                @change="refreshTable()"
                >Published Only</vs-checkbox
              >
            </li>
            -->
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(no)="data">
          <div>{{ data.value }}</div>
        </template>
        <template v-slot:cell(Total_number_of_delegates)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
export default {
  components: {},
  data: () => ({
    selectedEvent: null,
    events: [],
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Title", key: "title", sortable: true, foot: "" },
      {
        label: "Value",
        key: "value",
        sortable: true,
        foot: ""
      }
    ],
    items: []
  }),
  watch: {},
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  created() {
    //this.order_id = this.$route.query.o;

    let data = {
      event_type: "session",
      e: this.e,
      s: this.s
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    Service.LiveEvent.gets(params).then(res => {
      this.events = res.data.rows.map(item => {
        return { text: item.pro_title, value: item.slug };
      });
    });
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      //   this.filter = e;
      //   this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      console.log(this.selectedEvent);
      if (this.selectedEvent != null) {
        setTimeout(() => {
          this.isBusy = true;
          let data = {
            e: this.selectedEvent
          };

          let params = Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

          params =
            params +
            "&" +
            Object.keys(ctx)
              .map(key => key + "=" + ctx[key])
              .join("&");

          return Service.Report.checkinDetail(params)
            .then(res => {
              this.data = res.data.map(item => {
                return {
                  ...item
                };
              });

              callback(this.data);
            })
            .catch(error => {
              callback([]);
            });
        }, 500);
      } else {
        callback([]);
      }
    },

    onFormChanged() {
      this.$refs.table.refresh();
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      this.data.map(item => {
        let r = [];
        //r["title"] = item["no"];

        rows.push({ title: item["title"], total: item["value"] });
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "Checkin_report.xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>
